import { Component, OnInit, ViewChild, ElementRef, Inject, ChangeDetectorRef, Input, QueryList, EventEmitter, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import {ErrorStateMatcher} from '@angular/material/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import { ProfileComponent, croppedimagedialog } from '../pages/profile/profile.component';
import { SocketService } from '../services/socket/socket.service';
import { PackComponent } from '../project/dashboard/pack/pack.component';
import { ShareDialogComponent } from '../project/dashboard/nav/sharedialog.component';
import { addMemberCompany, Contacts } from '../company-member/company-member.component';
import { ConfirmdialogComponent } from '../project/dashboard/confirmdialog/confirmdialog.component';

@Component({
  selector: 'app-contacts-member',
  templateUrl: './contacts-member.component.html',
  styleUrls: ['./contacts-member.component.scss']
})
export class ContactsMemberComponent implements OnInit {

  contacts/*: Array<Contacts>*/ = [];
    searchContact: any;
    currentUser = null;
    confirm_mode = false;
    array_user_add = [];
    array_exised_user = [];
    admin = false;
    userEmail = '';
    @ViewChild('fileInput', {static: false}) fileInput: ElementRef;
    img: any;
    imageFil = null;
    @Output() groupQuit = new EventEmitter<any>();
    @Output() showProject = new EventEmitter<void>();
    @Output() groupCreated = new EventEmitter<void>();
    imgExists: boolean = true;
    
    step = 1;
    showHistoryModal = false;
    viewMode: 'table' | 'timeline' = 'table';
    selectedContact: any = null;
    commonProjects: any[] = [];
    loadingProjects: boolean = false;
    projectDetails = null;
    @Output() groupSlected = new EventEmitter<any>();
    vibrantColors = [
      "#e7e0ff", // bleu très clair
      "#caf1ee", // vert très clair
      "#fff0d3", // orange clair
      "#fbd8dc", // rose clair  #fdc1c8
      "#d8fdd2", // violet clair
      "#f4ded1", // turquoise clair   fdc1c8
      "#d1e8ff", // mauve clair
      "#cbf2ef"
    ];

    colorMap: Record<string, string> = {
      '#e7e0ff': '#5d45de', // bleu → violet foncé
      '#caf1ee': '#008476', // vert → vert foncé
      '#fff0d3': '#9d6b2b', // orange → brun
      '#fbd8dc': '#cd0635', // rose → bordeaux
      '#d8fdd2': '#1c8555', // vert → vert foncé
      '#f4ded1': '#855436', // beige → marron
      '#d1e8ff': '#0060d3', // bleu → bleu foncé
      '#cbf2ef': '#008379'  // turquoise → turquoise foncé
    };
    replaceData = {
      oldemail: '',
      email: '',
      password: '',
      givenName: '',
      familyName: ''
    };

    selectedUser: any;
  
    constructor(private authService: AuthService, private socketService: SocketService, private router: Router,  public  dialog: MatDialog, private cd: ChangeDetectorRef) { 
    }

    darkenColor(bgColor: string) {
      if (!bgColor) return '#444';
      const key = bgColor.toLowerCase().substring(0, 7);
      return this.colorMap[key] || '#444'
    }

    getUserBackground(contact){
      if(!contact || !contact.company) return;
      if(contact.roles.includes('ROLE_MANAGER') && contact.company.id === this.currentUser.compId){
        return "#f7f0d5";
      } else if(contact.company && contact.company.id === this.currentUser.compId){
        return "#e0eefa";
      } else return "#f7f0d5";
    }

    openProject(project){
      this.showProject.emit(project);
    }

    replaceTurnover(contact = null){
      this.selectedUser = contact;
      this.replaceData.oldemail = contact.email;
      this.replaceData.givenName = contact.givenName;
      this.replaceData.familyName = contact.familyName;
      this.step = 4;
    }

    historyTurnover(contact = null){
      this.selectedUser = contact;
      this.replaceData.oldemail = contact.email;
      this.replaceData.givenName = contact.givenName;
      this.replaceData.familyName = contact.familyName;
      this.showHistoryModal = true;
    }

    closeHistoryModal() {
      this.showHistoryModal = false;
    }

    replaceUser() {
      if(confirm("Voulez vraiment remplacer l'utilisateur "+this.replaceData.oldemail+" par "+this.replaceData.email)) {
        //return;
        this.authService.replaceUser(this.selectedUser.id, this.replaceData)
        .subscribe(() => {
          this.goBackChoiceAfterUpdate();
        });
      }
    }
  
    goBackChoiceAfterUpdate(){
      if(this.step === 3 || this.step === 4) {
        this.step = 2;
        this.showHistoryModal = false;
        this.selectedContact.email = this.replaceData.email;
        this.selectedContact.givenName = this.replaceData.givenName;
        this.selectedContact.familyName = this.replaceData.familyName;
        this.replaceData = null;
        this.contacts.find(contact => contact.id === this.selectedUser.id).email = this.replaceData.email;
      }
    }

    CreateOneToOne(contact = null){
          if(!contact) return;
          if (contact.fullName.trim().length > 0 ){
            this.authService.existPrivateProject(contact.email).subscribe(res => {
              var resultat = ''+res;
              if(resultat === 'false'){
                this.createOnetoOneProject(contact);
              } else {
                  for (let userProject of res["userProject"]) {
                    if (userProject.user && userProject.user.id === this.currentUser.id && userProject.status == "PENDING") {
                        const dialogRef = this.dialog.open(ConfirmdialogComponent, {
                          data: { 
                            message: 'Une invitation de cet utilisateur est déjà en attente. Voulez-vous l\'accepter ?',
                            title: 'Confirmation'
                          },
                          panelClass: 'confirmclass',
                          backdropClass: 'custom-backdrop'
                        });
                    
                        dialogRef.afterClosed().subscribe(result => {
                          if (result) {
                            this.onClickAccepter(userProject.id, res);
                          } else {
                            //console.log('L\'utilisateur a annulé la suppression');
                          }
                        });
    
                      return;
                    } else if(userProject.user && userProject.user.id === this.currentUser.id && userProject.status == "ACCEPTED"){
                      this.groupSlected.emit(res);
                    }
                  }
              }
            });  
          }
    }

    createOnetoOneProject(contact = null, email = null){
      if(!contact && !email) return;
      
      let arrayUserProject = [];
      var id = null;
      var fullName = email;
      if(contact) {
        id = contact.id;
        fullName = contact.fullName
        arrayUserProject.push({"user":"/api/users/"+contact.id, "isAdmin": true});
      }
      if(email) {
        arrayUserProject.push({"email":email, "prenom": "", "nom": "", "metier": "", "isAdmin": true});
      }
      
      this.authService.createProject(fullName, null, null, null, arrayUserProject, "PARENT", null, null, false, true, id).subscribe(
        res => {
          this.projectDetails = res;
          this.groupCreated.emit(this.projectDetails);
        },
        (error) => {
          alert('Erreur ! : ' + error);
        }
      );

    }

    onClickAccepter(invitationID, res) {
      var projectId = res["id"];
      this.authService.accepterProjet(invitationID).subscribe(dataAccepte => {
        this.socketService.sendInstant({
          id: "0",
          action: "0",
          type: "PROJECTINVITATION",
          author: this.currentUser.id,
          author_name: "",
          recipient: projectId,
          text: "",
          copy: "",
          private: false,
          res: "",
          project_lib: "",
          date: ""
        });
        this.groupCreated.emit(res);
        this.authService.getUserInvitation(0, 10).subscribe(res => {
          this.authService.obInviteBadge.next(res);
        });
      }, (error) => {
        alert('une erreur est survenue');
      });
    }
  
    ngOnInit() {
      this.step = 1;
      this.confirm_mode = false;
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.img = (this.currentUser.comImage ? this.getCompanyUrl(this.currentUser.comImage) : '../../assets/img/default-avatar.png');
      this.checkImageExists(this.img)
      //this.admin = this.currentUser.roles.includes('ROLE_MANAGER');
      this.admin = true;
      this.userEmail = this.currentUser.email;
      //this.currentUser.company = "bd5bcc26-9734-4e52-8074-01e827715298";
      if (this.currentUser.compId) {
        this.loadContact();
      }
      this.authService.obUpdateCompany.subscribe((res) => {
        if(res){
          this.setCompanyImage(res);
        } 
      });
    }
  
    getRandomColor(): string {
      const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
      return this.vibrantColors[randomIndex];
    }
  
    getInitials(libelle: string): string {
      if(libelle){
        const words = libelle.split(' ');
        const getFirstChar = (word: string): string => {
          return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
        };
        const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point
  
        return initials;
      }
    }
  
    checkImageExists(url: string): void {
      const img = new Image();
      img.crossOrigin = 'Anonymous';  // Si tu veux permettre CORS
      img.src = url;
    
      // Pour s'assurer de gérer toutes les erreurs
      img.onload = () => {
        this.imgExists = true;  // L'image se charge correctement
      };
    
      img.onerror = (error) => {
        this.imgExists = false;  // Si l'image ne se charge pas
        this.getCurrentCompany();
      };
    }
  
    getCurrentCompany(){
      var idcompany = JSON.parse(localStorage.getItem('currentUser')).compId;
       this.authService.getInfoCompany(idcompany)
       .subscribe( dataContact => {
          var logo  = dataContact['logo'];
          this.img = (logo ? this.getCompanyUrl(logo) : '../../assets/img/default-avatar.png');
          this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
          this.currentUser.comImage = logo;
          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
       }, (error) => {
       });
   
     }
    
  
     setCompanyImage(message = null){
      if(message){
        var logo  = message.res.logo;
        this.img = (logo ? this.getCompanyUrl(logo) : '../../assets/img/default-avatar.png');
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.currentUser.comImage = logo;
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
      }
     }
  
    goBackChoice(){
      if(this.step === 3 || this.step === 4) {
        this.showHistoryModal = false;
        this.step = 2;
        this.selectedUser = null;
      }else if (this.step === 2) {
        this.step = 1;
        this.selectedContact = null;
      } else this.groupQuit.emit('param');
    }

    openShareDialog() {
        const dialogRef = this.dialog.open(ShareDialogComponent, {
          panelClass: 'sharedialog-container'}
        );
    
        dialogRef.afterClosed().subscribe(result => {
        });
    }

    goToCommonProjects() {
      if (!this.selectedContact || !this.selectedContact.id) {
        console.error('Aucun contact sélectionné');
        return;
      }

      this.step = 3;
      this.loadingProjects = true;
      this.commonProjects = [];

      // Appelez votre service pour récupérer les projets en commun
      this.authService.getCommonProjects(0, 100, this.selectedContact.id).subscribe(
        (response: any) => {
          if(response){
            this.loadingProjects = false;
            this.commonProjects = response["hydra:member"];
            console.log('Projets en commun récupérés:', this.commonProjects);
          }
        },
        (error) => {
          this.loadingProjects = false;
          console.error('Erreur lors de la récupération des projets:', error);
          // Vous pouvez afficher un message d'erreur à l'utilisateur ici
          // this.snackBar.open('Erreur lors du chargement des projets', 'OK', { duration: 3000 });
        }
      );
    }

    openPrivateChat() {
      // Implémentez l'ouverture du chat privé
      console.log('Ouverture du chat privé avec', this.selectedContact);
    }
  
    loadContact() {
      this.authService.getMyContacts(this.currentUser['compId']).subscribe(res => {
        this.contacts = res['hydra:member'];
        this.contacts = this.contacts.sort(function (a, b) {
          if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) { return -1; }
          if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) { return 1; }
          return 0;
      })
        this.contacts.forEach(contact => {
          contact.color = this.getRandomColor();
        });
        this.loadContactNotRegister();
      },
        err => {
          const error = err.error;
          const errorS = error.message;
          const errorD = error.detail;
          const errorH = error['hydra:description'];
          if (errorS === 'Bad credentials') {
             alert(errorS);
          } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
            alert(errorD);
          } else if (errorH) {
            alert(errorH);
          }
        });
    }
  
    fileChangeEvent(event: any): void {
      const dialogRef = this.dialog.open(croppedimagedialog, {
        width: '700px',
        data: {event: event}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result !== null) {
          this.img = result.event;
          const reader = new FileReader();
          this.imageFil = result.fileToReturn;
  
          reader.readAsDataURL(this.imageFil);
            
          reader.onload = () => {
            this.cd.markForCheck();
          }; 
          if(this.imageFil) {
            this.authService.udapteCompanyImage(this.imageFil).subscribe( data => {
              this.socketService.sendInstant({
                id: "0",
                action: "0",
                type: "UPDATECOMPANY",
                author: this.currentUser.id,
                recipient: "",
                text: "",
                copy: "",
                private: false,
                res: data,
                project_lib: "",
                date: ""
              });
            }, (error) => {
                alert('une erreur est survenue');
            });
          
          }
        }
      });
    }
  
    showProfil(contact): void{
      this.step = 2;
      this.selectedContact = contact;
      return;
      var idUser = contact.id;
      if(!idUser) return;
      
      const dialogConfig = new MatDialogConfig();
      dialogConfig.panelClass = 'contactpanel';
      dialogConfig.data = { idUser: idUser};
      const dialogRef = this.dialog.open(ProfileComponent, {
        data: { idUser: idUser},
        panelClass: 'transferclass',
        backdropClass: 'custom-backdrop'
      });
      
      dialogRef.afterClosed().subscribe((result: any) => {
      });
      
    }
  
    loadContactNotRegister() {
      this.authService.getCompagnyMemberNotRegister().subscribe(res => {
        var contact_not_resgiter = res['hydra:member'];
        for (var i = 0; i < contact_not_resgiter.length; i++) {
          var contactUser = <Contacts>contact_not_resgiter[i];
          contactUser.invitation = true;
          contactUser.value = contact_not_resgiter[i].value;
          const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
          contactUser.color = this.vibrantColors[randomIndex];
          contactUser.familyName = contact_not_resgiter[i].value;
          contactUser.familyName = contact_not_resgiter[i].value;
          contactUser.givenName = "";
          contactUser.color = this.getRandomColor();
          var contact = this.contacts.find(contact => contact.email === contactUser.value);
          if(!contact) this.contacts.push(contactUser);
          //this.contacts.push(contactUser);
        }
      },
        err => {
          const error = err.error;
          const errorS = error.message;
          const errorD = error.detail;
          const errorH = error['hydra:description'];
          if (errorS === 'Bad credentials') {
             alert(errorS);
          } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
            alert(errorD);
          } else if (errorH) {
            alert(errorH);
          }
        });
    }
  
    goToProfile(profilId) {
      this.router.navigate(['/profile/' + profilId]);
    }
  
    getAvatarlUrl(avatarLink) {
      return environment.server_url + avatarLink;
    }
  
    getCompanyUrl(avatarLink) {
      return environment.server_url+"/media/project_img/" + avatarLink;
    }
  
    deleteUserFromCompany(profilId) {
      this.authService.deleteUserCompany(profilId).subscribe(res => {
         this.loadContact();
      },
        err => {
          const error = err.error;
          const errorS = error.message;
          const errorD = error.detail;
          const errorH = error['hydra:description'];
          if (errorS === 'Bad credentials') {
             alert(errorS);
          } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
            alert(errorD);
          } else if (errorH) {
            alert(errorH);
          }
      });
    }
  
    fctAddMember() {
        const dialogRef = this.dialog.open(addMemberCompany, {
          panelClass: 'dashboarddialog-container',
          data: {idcompany: this.currentUser['compId'], companyUser: this.contacts}
        });
  
        dialogRef.afterClosed().subscribe(result => {   
        });
    }
  
    uploadFile(file) {
  
      this.authService.addMultipEmploye(file.item(0)).subscribe(
        res => {
          this.array_exised_user = res['user_existed'];
          this.array_user_add = res['user_invited'];
          this.confirm_mode = true;
          this.loadContact();
        },
        (error) => {
          if (error.status === 403) {
            this.openPackComponentDialog(1);
          } else if (error.status === 429) {
            this.openPackComponentDialog(3);
          } else if (error.status === 402) {
            const errorDescription = JSON.parse(error.error['hydra:description']);
            this.openPackComponentDialog(2, errorDescription.subscriptionPack);
          } else {
            alert('Erreur ! : ' + error);
            this.confirm_mode = false;
          }
        }
      );
  
      this.fileInput.nativeElement.value = '';
  
    }
  
    openPackComponentDialog(type = 0, currentPack = 'free'){
      const dialogRef = this.dialog.open(PackComponent, {
        panelClass: 'packclass',
        backdropClass: 'custom-backdrop-pack',
        height: "height: calc(-80px + 100vh);",
        data: { type: type, pack: currentPack}
      });
  
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  
    goToMembers(){
      this.confirm_mode = false;
    }
  
  
     
  }